import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class WorkshopSteps extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'WorkshopSteps'
  // Define default properties here
  static instanceDefaults () {
    return {
      parentWorkshopStepId: null,
      name: '',
      position: 0,
      settings: {
        requiresLayerSourceIds: [],
      },
    }
  }
}
const servicePath = 'workshop-steps'
const servicePlugin = makeServicePlugin({
  Model: WorkshopSteps,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
